<template>
  <div class="modal">
    <div class="mask"></div>
    <div :class="fit ? 'fit-content contenido-modal' : 'contenido-modal'">
      <div v-if="showMovilHeader" class="movil-header">
        <button @click="closeModal" type="button" class="btn-close"></button>
      </div>
      <div v-if="showHeader" class="modal-header">
        <span>{{ header }}</span>
        <button @click="closeModal" type="button" class="btn-close">X</button>
      </div>
      <v-btn color="primary" class="ma-4" @click="imprimir()">
        <v-icon class="mr-2">mdi-printer</v-icon>Ticket
      </v-btn>
      <div :class="cuerpoModal" class="cuerpo-modal">
        <div class="contenedor-principal" id="printMe">
          <div class="content">
            <div class="contenedor-header">
              <img src="../../assets/imgs/logorm.svg" alt="icon-logo" />
              <span class="tipo-ticket">*** Ticket Técnico ***</span>
            </div>
            <div class="info-dinamica">
              <div class="info-top">
                <div>
                  <span class="title-info">Fecha: </span>
                  <span class="info-value-top">{{ getFecha }}</span>
                </div>
                <div>
                  <span class="title-info">Cliente: </span>
                  <span class="info-value-top"> {{ datos?.cliente }}</span>
                </div>
                <div style="margin-bottom: 20px">
                  <span class="title-info">Teléfono: </span>
                  <span class="info-value-top"> {{ getTelefono }}</span>
                </div>
                <!-- Datos del automovil -->
                <div class="detalle-row">
                  <div class="info-item">
                    <span class="columm-title">Auto </span>
                    <span class="info-value">{{ datos?.marca }}</span>
                  </div>
                  <div class="info-item">
                    <span class="columm-title">Modelo </span>
                    <span class="info-value"> {{ datos?.modelo }} </span>
                  </div>
                  <div class="info-item">
                    <span class="columm-title">Color </span>
                    <span class="info-value"> {{ datos?.color }} </span>
                  </div>
                  <div class="info-item">
                    <span class="columm-title">Placas </span>
                    <span class="info-value"> {{ datos?.placas }} </span>
                  </div>
                </div>

                <div class="detalle-row">
                  <div class="info-item">
                    <span class="columm-title column-doble">Motor </span>
                    <span class="info-value"> {{ datos?.motor }} </span>
                  </div>
                  <div class="info-item">
                    <span class="columm-title column-doble">Cilindros </span>
                    <span class="info-value"> {{ datos?.cilindros }} </span>
                  </div>

                  <div class="info-item">
                    <span class="columm-title column-doble">Kilometraje </span>
                    <span class="info-value">{{
                      `${fm.from(datos?.kilometraje ? datos.kilometraje : 0 )}km`
                    }}</span>
                  </div>

                  <div class="info-item">
                    <span class="columm-title column-doble">Tipo de transmisión</span>
                    <span class="info-value"> {{ datos?.transmision }} </span>
                  </div>
                </div>

                <div class="detalle-row">
                  <div class="info-item">
                    <span class="columm-title column-doble">Tipo de motor</span>
                    <span class="info-value"> {{ datos?.tipoMotor }} </span>
                  </div>
                  <div class="info-item">
                    <span class="columm-title column-doble">Tracción </span>
                    <span class="info-value"> {{ datos?.traccion }} </span>
                  </div>
                  <div class="info-item">
                    <span class="columm-title column-doble"
                      >Aire Acondicionado</span
                    >
                    <span class="info-value">{{
                      datos?.aireAcondicionado == 1 ? 'SI' : (datos?.aireAcondicionado == 3 ? 'NO FUNCIONA' : 'NO')
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="columm-title column-doble"
                      >Candado ruedas
                    </span>
                    <span class="info-value"> {{ datos?.candado }} </span>
                  </div>
                </div>

                <div style="display: flex; margin-bottom: 20px">
                  <span class="title-info">Lavado: </span
                  ><span class="info-value-top" style="margin-left: 5px;"> {{datos?.lavado == 1 ? ' Autorizado' : ' No Autorizado'}} </span>
                </div>
                <div class="reporte">
                  <span class="title-info">Reporte de cliente: </span>
                  <span class="info-value-top txt-reporte">
                    {{datos?.reporteCliente}}
                  </span>
                </div>
                <div style="min-height:20px;"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { FormatMoney } from "format-money-js";
import moment from "moment";
export default {
  name: "TicketTecnico",
  components: {},
  props: {
    header: {
      type: String,
      default: "Ticket Técnico",
    },
    showMovilHeader: {
      type: Boolean,
      default: false,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    fit: {
      type: Boolean,
      default: false,
    },
    cuerpoModal: {
      type: String,
      default: "",
    },
    datos: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    getFecha() {
      
      return moment(this.datos?.fecha).format("YYYY/MM/DD hh:mm a");
    },
    getCliente() {
      return this.datos?.cliente;
    },
    getTelefono() {
      return this.datos?.telefono;
    },
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },

    imprimir() {
      let imprimir = "";
      imprimir = document.getElementById("printMe");
      var ventana = "";
      let tituloImpresion = "Ticket tecnico";

      ventana = window.open("", "PRINT", `height=400,width=600`);
      ventana.document.write(
        "<html><head><title>" + tituloImpresion + "</title>"
      );
      ventana.document.write(
        '<link rel="stylesheet" href="/css/ticketTecnico.css">'
      );
      ventana.document.write("</head><body >");
      ventana.document.write(imprimir.innerHTML);
      ventana.document.write("</body></html>");
      ventana.document.close();
      ventana.focus();
      setTimeout(() => {
        ventana.print();
        ventana.close();
      }, 2000);
    },
  },
  emits: ["closeModal"],
  data() {
    return {
      fm: new FormatMoney({
        decimals: 0,
      }),
    };
  },
};
</script>
<style scoped>
.movil-header {
  display: none;
}

.fit-content {
  height: min-content;
  min-width: 300px;
  min-height: min-content !important;
  max-width: fit-content !important;
}

.modal {
  display: none;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  align-items: center;
  display: flex;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  padding: 20px;
  padding-bottom: 10px;
  padding-top: 10px;
}
.mask {
  background-color: transparent;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
}
.contenido-modal {
  position: relative;
  background-color: #ffffff;
  margin: auto;
  border-radius: 10px;
  min-width: 320px;
  box-shadow: 0px 3px 6px #00000029;
  -webkit-animation-name: animatetop;
  -webkit-animation-duration: 0.4s;
  animation-name: animatetop;
  animation-duration: 0.4s;
  box-sizing: border-box;
  z-index: 1000;
  width: 420px;
  height: fit-content;

  max-width: 100vw;
}
.modal-header {
  border-radius: 6px 6px 0 0;
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 15px;
}
.modal-header span {
  flex: 1;
  font-weight: 600;
  text-align: left;
  font: normal normal bold 18px/27px Open Sans;
  letter-spacing: 0px;
  color: #4873d3;
  opacity: 1;
  margin-top: 10px;
  text-align: center;
  font-size: 25px;
}

.btn-close {
  font-size: 25px;
  font-weight: bold;
  color: #000;
  cursor: pointer;
}

.contenido-modal .close {
  display: flex;
  margin-left: auto;
  margin-right: 20px;
  margin-top: -10px;
  cursor: pointer;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.3s;
}

.contenido-modal .close:hover {
  background-color: #f2f2f2;
  transition: 0.3s;
}
.contenido-modal .cuerpo-modal {
  overflow-y: auto;
  padding: 0px 10px;
}
.contenido-modal .cuerpo-modal.overflow {
  overflow-y: visible;
  padding: 35px;
}
.cuerpo-modal .contenedor-status {
  text-align: left;
  font: normal normal 600 14px/19px Open Sans;
  letter-spacing: 0px;
  opacity: 1;
}

@-webkit-keyframes animatetop {
  from {
    top: -500px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
@keyframes animatetop {
  from {
    top: -500px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}

@media (max-width: 1279px) {
  .contenido-modal {
    min-height: 400px;
    max-width: 100vw;
    border-radius: 6px;
    padding: 0;
    box-shadow: 0px 3px 6px #3d424bb2;
  }
}

@media (max-width: 767px) {
  .movil-header {
    width: 100%;
    height: 60px;
    background-color: #0a4f9c;
    position: relative;
  }

  .movil-header .btn-close {
    position: absolute;
    top: 4px;
    right: 10px;
    filter: brightness(0) invert(1);
  }
  .movil-header .btn-close:hover {
    filter: none;
    background-color: #fff;
  }
  .modal-header {
    margin-bottom: 10px;
  }

  .modal-header span {
    font: normal normal bold 14px/27px Open Sans;
  }

  .contenido-modal {
    height: min-content;
    min-height: 300px;
  }
}
</style>
<style scoped src="@/assets/css/ticketTecnico.css"></style>